import Card from "../UI/Card";
import { useContext, Fragment, useEffect, useState } from "react";
import classes from "./Article.module.css";
import galleryClasses from "../Gallery/Photos.module.css";
import galleryHelpers from "../../store/gallery-helper";

import PolandContext from "../../store/poland-context";
import Modal from "../UI/Modal";

import photoAct1 from "../../assets/polandArticle/IMG_1088.JPG";
import photoAct2 from "../../assets/polandArticle/IMG_1086.JPG";
import photoAct3 from "../../assets/polandArticle/IMG_1381.jpg";
import photoAct4 from "../../assets/polandArticle/IMG_1384.jpg";
import photoAct5 from "../../assets/polandArticle/exhibition.png";
import photoMeet1 from "../../assets/polandArticle/16.JPG";
import photoMeet2 from "../../assets/polandArticle/13.JPG";
import photoMeet3 from "../../assets/polandArticle/6.JPG";
import photoMeet4 from "../../assets/polandArticle/7.JPG";
import photoMeet5 from "../../assets/polandArticle/4.JPG";
import photoMeet6 from "../../assets/polandArticle/22.JPG";
import videoMeet from "../../assets/polandArticle/erasmusDisco.mp4";
import pdf1 from "../../assets/polandArticle/pdfs/Erasmus 2019_prezentacjaPL.pdf";
import pdf2 from "../../assets/polandArticle/pdfs/Power_MKozłowska-kopia.pdf";

const PolandArticle = (props) => {
  const polCtx = useContext(PolandContext);
  const [isZoomedIn, setIsZoomedIn] = useState(false);
  const [currentPhoto, setCurrentPhoto] = useState("");

  const content = polCtx.activities.photos.starsPhotos.map((photo) => (
    <img
      key={photo}
      onClick={() =>
        galleryHelpers.zoomInHandler(photo, setIsZoomedIn, setCurrentPhoto)
      }
      src={photo}
      alt=""
    />
  ));

  useEffect(() => {
    document
      .getElementById(props.id)
      .scrollIntoView({ behavior: "smooth", block: "start" });
  }, [props.id]);

  return (
    <Fragment>
      <p className="main" id="act"></p>
      <Card>
        <div>
          <h1 className={classes.header}>School Project Activities</h1>
          <p className={classes.text}>{polCtx.activities.pl[0]}</p>
          <p className={classes.text}>{polCtx.activities.en}</p>
          <div className={classes.images}>
            <article>
              <img className={classes.image} src={photoAct1} alt="" />
              <p className={classes.center}>Zespół Erasmusa - uczniowie</p>
            </article>
            <article>
              <img className={classes.image} src={photoAct2} alt="" />
              <p className={classes.center}>Erasmus Team - Students</p>
            </article>
          </div>
          <p className={classes.text}>{polCtx.activities.pl[1]}</p>
          <div className={`${classes.images} ${classes.center}`}>
            <article>
              <img className={classes.image} src={photoAct3} alt="" />
              <p className={classes.center}>Wystawa</p>
            </article>
            <article>
              <img className={classes.image} src={photoAct5} alt="" />
              <p className={classes.center}>Wystawa</p>
            </article>
            <article>
              <img className={classes.image} src={photoAct4} alt="" />
              <p className={classes.center}>Our exhibition</p>
            </article>
          </div>
          <div className={classes.text}>{polCtx.activities.pl[2]}</div>
          <div className={galleryClasses.wrapper}>{content}</div>
          {isZoomedIn && (
            <Modal
              onHidePhoto={() => {
                galleryHelpers.zoomOutHandler(setIsZoomedIn);
              }}
              photo={currentPhoto}
            />
          )}
        </div>
      </Card>
      <Card>
        <h1 className={classes.header}>Konspekty zajęć</h1>
        <p className={classes.text}>
          W wyniku działań projektowych i zaangażowania w nie nauczycieli
          różnych przedmiotów powstały m.in. konspekty z zakresu edukacji
          wczesnoszkolnej uwzględniające włączanie do nauczania elementów języka
          angielskiego. Bowiem jednym z zakładanych trwałych efektów naszego
          projektu było właśnie wzbogacanie nauczania przedmiotów
          ogólnokształcących elementami języka angielskiego. Ten proces już się
          rozpoczął, będzie kontynuowany i stale rozszerzany.
        </p>
        <p className={classes.text}>
          As a result of project activities and the involvement of teachers of
          various subjects in them, there were many long lasting effects
          created. For example: lesson plans for early childhood education with
          bilingual elements of English language. One of the assumed lasting
          effects of our project was the improvement of general education with
          bilingual elements of English language. This process has already
          started and it will be continued and what is more it will be
          continuously expanded.
        </p>
        <div className={classes.center}>
          <div className={classes.frame}>
            <iframe
              title={"iframe"}
              src={pdf2}
              className={classes.iframe}
              width="100%"
              height="100%"
            >
              <div>No PDF viewer available</div>
            </iframe>
          </div>
        </div>
      </Card>

      <p className="main" id="meet"></p>
      <Card>
        <h1 className={classes.header}>Project Meeting in Poland</h1>
        <p className={classes.text}>{polCtx.meeting.pl[0]}</p>
        <div className={classes.center}>
          <img className={classes.single} src={photoMeet1} alt="" />
        </div>
        <p className={classes.text}>{polCtx.meeting.pl[1]}</p>
        <div className={classes.center}>
          <img className={classes.single} src={photoMeet2} alt="" />
        </div>
        <p className={classes.text}>{polCtx.meeting.pl[2]}</p>
        <div className={classes.center}>
          <video className={classes.video} controls>
            <source src={videoMeet} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <p className={classes.text}>{polCtx.meeting.pl[3]}</p>
        <div className={classes.center}>
          <img className={classes.single} src={photoMeet3} alt="" />
        </div>
        <p className={classes.text}>{polCtx.meeting.en[0]}</p>
        <p className={classes.text}>{polCtx.meeting.en[1]}</p>
        <div className={classes.center}>
          <img className={classes.single} src={photoMeet4} alt="" />
        </div>
        <p className={classes.text}>{polCtx.meeting.en[2]}</p>
        <div className={`${classes.images} ${classes.center}`}>
          <article>
            <img className={classes.image} src={photoMeet5} alt="" />
          </article>
          <article>
            <img className={classes.image} src={photoMeet6} alt="" />
          </article>
        </div>
      </Card>
      <Card>
        <h1 className={classes.header}>"Nasza mała ojczyzna"</h1>
        <p className={classes.text}>
          W ramach realizacji założeń projektowych stworzyliśmy prezentację
          przedstawiającą „Naszą małą Ojczyznę”. Na bazie tej prezentacji
          powstały broszury, które przekazaliśmy naszym partnerom i
          rozpowszechniliśmy je jako efekt materialny projektu w szkołach w
          regionie.
        </p>
        <p className={classes.text}>
          „Our little Homeland” is a presentation that was created by all of the
          participants. Based on that presentation, we created some brochures
          which we passed on to our partners and we shared them as a durable
          lasting effect of the project in schools in the region.
        </p>
        <div className={classes.center}>
          <div className={classes.frame}>
            <iframe
              title={"iframe"}
              src={pdf1}
              className={classes.iframe}
              width="100%"
              height="100%"
            >
              <div>No PDF viewer available</div>
            </iframe>
          </div>
        </div>
      </Card>
    </Fragment>
  );
};

export default PolandArticle;
